import React from "react";
import { AnimatePresence } from "framer-motion";
import NeonGridBackground from "./src/components/neon-grid-background";
import CursorManager from "./src/components/cursor-manager";
require("./src/components/prism-gruvbox-dark.css");

export const wrapPageElement = ({ element }) => (
    <AnimatePresence mode="wait" initial={false}>
        {element}
    </AnimatePresence>
);

export const wrapRootElement = ({ element }) => (
    <>
        {/* z-index: 0 — sits behind all content */}
        <NeonGridBackground />

        {/* z-index: 9999 — floats above everything, pointer-events: none */}
        <CursorManager />

        {element}
    </>
);